export default {
  name: 'MaiFamilyCard',
  template: `
<div class="loyalty-member-card loyalty-member-card--maifamily">
  <div class="loyalty-member-card__image">
    <img src="https://res.cloudinary.com/maistra/image/upload/v1793266173/MaiFamilyRates_u2phuo.svg" alt="MaiFamily" width="277" height="71">
  </div>

  <div class="loyalty-member-card__info">
    <a :href="aboutUrl" class="arrow-button">
      <span>{{ aboutText }}</span>
      <i class="icon-arrow-right-long"></i>
    </a>
  </div>
</div>
  `,
  props: {
    aboutUrl: String,
    aboutText: String,
  },
}
